import { spawn } from 'utils/translations';
import acceptInvitePreview from '/images/bitbucket-installation/accept-invite-preview.png';
import createAccountPreview from '/images/bitbucket-installation/create-account-preview.png';
import inviteUserPreview from '/images/bitbucket-installation/create-bot-user-preview.png';

const spawnCreate = spawn('dialogs.bitbucket-installation.create-bot-user');

export const getSubSteps = () => [
  {
    label: spawnCreate('sub-step-invite-user'),
    image: inviteUserPreview,
    alt: spawnCreate('sub-step-invite-user-alt'),
  },
  {
    label: spawnCreate('sub-step-create-account'),
    image: createAccountPreview,
    alt: spawnCreate('sub-step-create-account-alt'),
  },
  {
    label: spawnCreate('sub-step-login-with-qodo'),
    image: acceptInvitePreview,
    alt: spawnCreate('sub-step-login-with-qodo-alt'),
  },
];
